import React from "react";
import { AUDITS, DRINKS } from "./coffeeUi";
import CoffeePeriod from "./CoffeePeriod";
import CoffeePhotos from "./CoffeePhotos";
export default function CoffeeFields({
  form,
  setForm,
  previous,
  first = false,
  editing = false,
  showPeriod = true,
  showPhoto = false,
  maxPhotos = 1,
  photoProcessing = false,
  onPhotoProcessingChange,
}) {
  const change = (key, value) => setForm((old) => ({ ...old, [key]: value }));
  const arrayChange = (key, index, value) =>
    setForm((old) => ({
      ...old,
      [key]: old[key].map((item, i) => (i === index ? value : item)),
    }));
  const number = (label, key, step = "1", required = false) => (
    <label>
      {label}
      <input
        type="number"
        min="0"
        step={step}
        required={required}
        value={form[key]}
        onChange={(e) => change(key, e.target.value)}
      />
    </label>
  );
  const base = first ? form.initialCounter : previous;
  return (
    <>
      {showPeriod && <CoffeePeriod form={form} setForm={setForm} />}
      <section>
        <h2>Contadores</h2>
        <div className="coffee-grid">
          {first || editing ? (
            number("Base inicial *", "initialCounter", "1", first)
          ) : (
            <label>
              Contador anterior
              <input readOnly value={previous ?? ""} />
            </label>
          )}
          {number("Contador actual *", "currentCounter", "1", true)}
          <div className="coffee-calculated">
            <span>Consumo calculado</span>
            <strong>
              {form.currentCounter !== "" && base !== "" && base != null
                ? Number(form.currentCounter) - Number(base)
                : "—"}
            </strong>
          </div>
        </div>
        <p className="coffee-hint">
          Si el contador se reinició, solicita a support registrar la nueva
          base.
        </p>
      </section>
      <section>
        <h2>Bebidas y pruebas</h2>
        <p className="coffee-hint">
          Cantidades del período. Los campos vacíos se guardan como no
          reportados.
        </p>
        <div className="coffee-grid">
          {DRINKS.map((name, i) => (
            <label key={name}>
              {name}
              <input
                type="number"
                min="0"
                step="1"
                value={form.drinks[i]}
                onChange={(e) => arrayChange("drinks", i, e.target.value)}
              />
            </label>
          ))}
          {number("Pruebas", "tests")}
        </div>
      </section>
      <section>
        <h2>Auditorías · USD</h2>
        <p className="coffee-hint">
          Opcionales. Valores de la visita; no se suman ni se restan.
        </p>
        <div className="coffee-grid">
          {AUDITS.map((name, i) => (
            <label key={name}>
              {name}
              <input
                type="number"
                min="0"
                step="0.01"
                value={form.audits[i]}
                onChange={(e) => arrayChange("audits", i, e.target.value)}
              />
            </label>
          ))}
        </div>
      </section>
      <section>
        <h2>Total Cobrado</h2>
        <div className="coffee-grid">
          {number("Total de ventas · USD", "totalSales", "0.01")}
        </div>
      </section>
      {showPhoto && (
        <section>
          <h2>Imágenes del registro</h2>
          <CoffeePhotos
            photos={form.photos || []}
            onChange={(value) => change("photos", value)}
            onProcessingChange={onPhotoProcessingChange}
            processing={photoProcessing}
            maxPhotos={maxPhotos}
          />
        </section>
      )}
    </>
  );
}
